class EFStoreAvailability extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Ensure data-variant-id is available before using it
    const variantId = this.dataset.variantId;
    if (!variantId) {
      console.error("Product ID is missing");
      return;
    }

    this.generateAvailability(variantId);
  }

  generateAvailability(variantId) {
    const elementToUpdate = document.getElementById("ef-store-list");
    if (!elementToUpdate) return; // Prevents errors if #ef-store-list doesn't exist

    console.log("variant ID:", variantId);

    const variantInventoryUrl = `https://api.redmanshop.com/api/inventory/location?variantId=${variantId}`;

    // const displayText = store.available <= 0 ? 'Out of stock' : store.available <= 10 ? 'Low stock' : 'Available';

    fetch(variantInventoryUrl)
      .then((response) => response.json())
      .then((res) => {
        if (!Array.isArray(res) || res.length === 0) {
          elementToUpdate.innerHTML = `<p>No stores have this item in stock.</p>`;
          return;
        }
        let listItems = res
          .map((store) => {
            const displayText =
              store.available <= 0
                ? "Out of stock"
                : store.available <= 10
                ? "Low stock"
                : "Available";
            return `
                <li class="location_info store-availability-list__item">
                    <div class="store-availability-list-header">
                        <div class="modal-heading__text">
                            <span class="store-availability-list-header__location text-size--large text-weight--bold">
                            ${store.locationName}
                            </span>
                            </span>
                        </div>
                        <span class="store-availability-list__stock alert 
                            ${
                              store.available <= 0
                                ? "alert--error"
                                : store.available < 10
                                ? "alert--low_stock"
                                : "alert--success"
                            } 
                            alert--circle alert--unstyled">
                            <span style="color:var(--color-text-main)">${displayText}</span>
                        </span>

                        <div  style="margin-inline-start: 1.375rem; display: none;">
                            <span class="text-size--small">
                            <p>
                                No.18
                                <br>
                                Jln 1/5, Tmn Univensity,
                                <br>
                                Seri Kembangan
                            </p>
                            </span>
                        </div>
                    </div>      
                </li>
            `;
          })
          .join("");

        elementToUpdate.innerHTML = `
                              
                <ul class="store-availabilities-list">${listItems}</ul>
            `;
      })
      .catch((e) => {
        console.error("Error fetching inventory:", e);
        elementToUpdate.innerHTML = `<p>Unable to load store availability.</p>`;
      });
  }
}

customElements.define("ef-store-availability", EFStoreAvailability);
